export default "__VITE_ASSET__BLErgrnp__"